import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router'
import { Skeleton, Result } from 'antd'
import permissionChecker, { PermissionResult } from '../../../helpers/permission-checker.helper'
import { AppRoutePermissionType } from '../../../navigation'

// Define component type
export type BaseComponentProps = RouteComponentProps & {
  children: any,
  name: string,
  userPermissions: string[],
  permissions?: AppRoutePermissionType
}

export default class BaseComponent extends Component<BaseComponentProps> {

  state = {
    lastPathname: '',
    basePermissions: null as PermissionResult | null
  }

  componentDidMount() {
    this.checkPermissions()
  }

  componentDidUpdate() {
    if (this.props.history.location.pathname !== this.state.lastPathname) {
      this.checkPermissions()
    }
  }

  checkPermissions = () => {
    const { permissions, userPermissions, history, match } = this.props

    if (permissions) {
      const params = match.params as any

      this.setState({
        lastPathname: history.location.pathname,
        basePermissions: permissionChecker(permissions, userPermissions, params.activeTab || undefined)
      })
    }
  }

  render() {
    const { children, match } = this.props
    const { basePermissions } = this.state

    if (basePermissions === null) return <Skeleton />

    const params = match.params as any
    return (
      <div>
      {
        (basePermissions.list || (params.activeTab)) && children ? children({ basePermissions: basePermissions }) : (
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
          />
        )
      }
      </div>
    )
  }
}

